(function($) {
	$.fn.historyNav = function(options) {
		var selector = this.data('selector') || '.article__nav';

		options = $.extend({
			selector: selector,
			articleSelector: selector.split('__')[0],
			prevSelector: selector+'--prev',
			nextSelector: selector+'--next'
		}, options);

		return $(this).on({
			click: function() {
				var direction = $(this).is(options.prevSelector) ? 'prev' : 'next',
					$prevNext = $(this).parents(options.articleSelector)[direction]();

				$(document).scrollTop($prevNext.offset().top - parseInt($prevNext.css('margin-top')) - ($('header').height() * 1.25));

                return false;
			}
		});
	}
})(jQuery);